import React, { Component } from "react";
import _ from 'lodash';
import { stringify } from 'query-string';
import { doctorService } from '../services/doctor';
import { languageService } from '../services/language';
import { userService} from '../services/user';

import '../assets/styles/Result.scss';
import map_icon from '../assets/images/map-icon.png';
import list_icon from '../assets/images/list-icon.png';
import filter_icon from '../assets/images/filter-icon.png';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';

import { ResultListView } from './ResultListView';
import { ResultMapView } from "./ResultMapView";
import { Error } from "./Error";
import Pagination from '@material-ui/lab/Pagination';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FilterModal } from "./FilterModal";

import ReactGA from 'react-ga';

import SEO from './SEO';

class Result extends Component {

    constructor(props){
        super(props);

        const query = new URLSearchParams(this.props.location.search);
        var selected_specialty, selected_location, selected_state;
        let startDate = moment().startOf('day');
        
        if (query.get('country') || query.get('location') || query.get('lat') || query.get('long') || query.get('country_id') || query.get('location_type')){
            selected_location = {
                name: query.get('country') || query.get('location'),
                lat: query.get('lat'),
                long: query.get('long'),
                id: query.get('country_id'),
                type: query.get('location_type')
            };    
        }
        if(query.get('state') || query.get('location')){
            selected_state = {
                name: query.get('state') || query.get('location'),
                id: query.get('state_id')
            };
        }
        if(query.get('specialty')){
            selected_specialty = {
                label: query.get('specialty'),
                value: {
                    type: query.get('type'),
                    name: query.get('specialty')
                }
            };
        }
        
        var insurance_id = null;
        if(query.get('insurance') && query.get('insurance').toLowerCase() === 'prudential'){
            insurance_id = process.env.REACT_APP_PRUDENTIAL_INSURANCE_ID
        }

        let metadata = {
            title: 'Search and book a doctor, dentist or other healthcare professionals hassle-free',
            description: 'Find a doctor, dentist, physiotherapist or other healthcare professionals and book appointments online instantly. You can search by location and specialty. It’s easy to use and free!',
            type: 'website'
        }

        let search_input_value = '';
        if(!_.isEmpty(this.props.location.state)){
            selected_location = this.props.location.state.location;
            startDate = moment(this.props.location.state.startDate);
            selected_specialty = this.props.location.state.selected_specialty;
            search_input_value = this.props.location.state.search_input_value;
            selected_state = this.props.location.state.selected_state;
        }

        let feature_options = global.constant.feature_options
        if((userService.getUser() && !_.isEmpty(userService.getUser().employee)) && !_.find(feature_options, {value: 'panel'})){
            feature_options.push({
                label: 'Panel Doctors',
                value: 'panel'
            });
        }

        if(selected_specialty && selected_specialty.label){
            metadata = {
                title: this.getMetaTitle(selected_specialty, selected_location, selected_state),
                description: this.getMetaDesc(selected_specialty, selected_location, selected_state),
                keywords: this.getMetaKeywords(selected_specialty, selected_location, selected_state),
                type: 'website'
            }
        }

        this.state = {
            selected_location: selected_location,
            selected_state: selected_state,
            startDate: startDate,
            specialties: [],
            search_input_value: search_input_value,
            selected_specialty: selected_specialty,
            location: {
                name: null,
                latitude: null,
                longitude: null
            },
            states: [],
            loading_result: false,
            loading_result_list: false,
            error_result: '',
            results: [],
            meta: {},
            activeView: "list_view",
            locations: [],
            result_pageindex: 1,
            meridiem: '',
            language: '',
            languages: [],
            showFilterModal: false,
            feature: '',
            feature_options: feature_options,
            metadata: metadata,
            insurance_id: insurance_id
        };

        this.handleToggleView = this.handleToggleView.bind(this);
        this.getResultsBasedOnDate = this.getResultsBasedOnDate.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.handleOnFav = this.handleOnFav.bind(this);
        this.handleFilterDateChange = this.handleFilterDateChange.bind(this);
        this.handleMeridiemChange = this.handleMeridiemChange.bind(this);
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.handleFeatureChange = this.handleFeatureChange.bind(this);
    }

    handleFilterModal = (isOpen) => this.setState({ showFilterModal: isOpen });

    handleToggleView(e) {
        const { name } = e.target;
        this.setState(() => ({
          activeView: name
        }));
    }

    getResults(date, location, specialty, pageindex, forSlots = false, state = {}){
        this.setState({
            loading_result_list: !forSlots,
            loading_result: true
        });

        if(!forSlots){
            document.getElementById("results-loader").classList.remove('d-none');
            document.getElementById("results-list").classList.add('d-none');
        }

        let params = {
            around: 3,
            date: moment(date, 'DD-MM-YYYY').format('YYYYMMDD'),
            perpage: 20,
            pageindex: pageindex
        }

        if(!_.has(specialty,'value')){
            specialty = {
                name: this.state.search_input_value,
                type: 'keyword'
            }
        }else{
            specialty = specialty.value;
        }

        if(specialty.type === 'doctor'){
            if(specialty.id === -1){
                params = {...params, ...{
                    type: specialty.type,
                    keyword: this.state.search_input_value.split(/["]/)[1]
                }}
            }else{
                params = {...params, ...{
                    type: specialty.type,
                    doctor_id: specialty.id
                }}
            }
        }else if(specialty.type === 'facility'){
            if(specialty.id === -1){
                params = {...params, ...{
                    type: specialty.type,
                    keyword: this.state.search_input_value.split(/["]/)[1]
                }}
            }else{
                this.props.history.push({
                    pathname:  `/search-book/clinic/${specialty.friendly_id}`
                });
            }
        }else{
            var locationParams = {}
            if(location && (location.type === undefined || location.type === null || location.type === 'current_location')){
                locationParams = {
                    lat: location.lat,
                    long: location.long,
                }
            }else{
                if(state && state.id){
                    locationParams = {
                        state_id: state.id
                    }
                }
            }
            if(location && location.id){
                locationParams['country_id'] = location.id;
            }

            if(specialty.type === 'common_name' || specialty.id === -1 || specialty.type === 'service'){
                params = {...params, ...{
                    type: specialty.type,
                    keyword: specialty.name
                }, ...locationParams}
            }else if(specialty.type === 'keyword'){
                params = {...params, ...{
                    keyword: specialty.name
                }, ...locationParams}
            }else{
                params = {...params, ...{
                    specialty_name: specialty.name
                }, ...locationParams}
            }
        }

        if(this.state.language){
            params = {...params, ...{
                language: this.state.language.toLowerCase()
            }}
        }

        if(!_.isEmpty(this.state.meridiem)){
            params = {...params, ...{
                meridiem: this.state.meridiem.value
            }}
        }

        if(!_.isEmpty(this.state.feature)){
            if(this.state.feature.value === 'online-booking'){
                params = {...params, ...{
                    is_using_calendar: 1
                }}
            }else if(this.state.feature.value === 'chat'){
                params = {...params, ...{
                    chat_enabled: 1
                }}

            }else if(this.state.feature.value === 'video-call'){
                params = {...params, ...{
                    video_enabled: 1
                }}
            }else if(this.state.feature.value === 'panel'){
                params = {...params, ...{
                    employer: userService.getUser().employee.employer_id
                }}
            }
        }
        if(!_.isEmpty(this.state.insurance_id)){
            params = {...params, ...{
                insurance: parseInt(this.state.insurance_id)
            }}
        }

        ReactGA.send({ hitType: "pageview", page: this.props.location.pathname + '?' + stringify(params) });

        doctorService.searchDoctors(params)
        .then(
            data => {
                if(data){
                    this.setState({
                        error_result: "",
                        results: data.doctors,
                        meta: data.meta
                    });
                }
            },
            error => {
                if (typeof error.json === "function") {
                    error.json().then(jsonError => {
                        this.setState({
                            error_result: jsonError.error
                        });
                    });
                } else {
                    this.setState({
                        error_result: 'Internal Server Error'
                    });
                    console.log('There has been a problem with your fetch operation: ',
                    error.message);
                }
            }
        ).then(() => {
            this.setState({
                loading_result_list: false,
                loading_result: false
            });
            if(!forSlots){
                let results_loader_class = document.getElementById("results-loader");
                let results_list_class = document.getElementById("results-list");

                if(results_loader_class)
                    results_loader_class.classList.add('d-none');

                if(results_list_class)
                    results_list_class.classList.remove('d-none');
            }
        });
    }

    getResultsBasedOnDate(date, forSlots = false){
        this.getResults(date, this.state.selected_location, this.state.selected_specialty, this.state.result_pageindex, forSlots, this.state.selected_state);
    }

    getCommons(){
        axios.get(process.env.REACT_APP_API_URL+'commons').then(res => {
            const specialties = res.data.map((common) => {
                common._label = common.name;
                return { value: common, label: common.name }
            });
            this.setState({ specialties });
        })
    }

    getLanguages(){
        languageService.get()
        .then(
            data => {
                if(data){
                    this.setState({
                        languages: _.sortBy(data.languages),
                    });
                }
            },
            error => {
                console.log(error)
            }
        );
    }

    getCountries = async () => {
        var _selected_location = this.state.selected_location;
        var canSearchByCurrentLocation = false;
        var currentLocationData;
      
        try {
          // Axios GET request with async/await
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL}doctors/available_locations`,
            {
              headers: { Accept: "application/laelia.v2" },
            }
          );
      
          // Populate locations from the response
          var locations = global.constant.available_countries;
          if (res.data) {
            locations = [
              {
                label: "Available Countries",
                type: "available_country",
                options: res.data.countries.map((country) => {
                  return { ...country, type: "available_country" };
                }),
              },
            ];
          }
      
          // Get current position
          if (locations) {
            if ("geolocation" in navigator) {
              try {
                // Await for the geolocation to finish
                await new Promise((resolve, reject) => {
                  navigator.geolocation.getCurrentPosition(
                    function (position) {
                      var checkLocExist = locations.findIndex(
                        (x) => x.type === "current_location"
                      );
      
                      if (checkLocExist < 0) {
                        currentLocationData = {
                          name: "Current Location",
                          lat: position.coords.latitude,
                          long: position.coords.longitude,
                          type: "current_location",
                        };
                        locations.unshift(currentLocationData);
                        if (
                          _selected_location === undefined ||
                          _selected_location === null ||
                          _selected_location === ''
                        ) {
                          canSearchByCurrentLocation = true;
                        }
                      }
                      resolve();
                    },
                    function (error) {
                      console.log("Error Code = eoo " + error.code + " - " + error.message);
                      reject(error);
                    }
                  );
                });
              } catch (error) {
                console.log("Geolocation Error:", error.message);
              }
            } else {
              console.log("Geolocation not available");
            }
          }
      
          // Update the state only after everything is done      
          this.setState({ locations });
          if (canSearchByCurrentLocation) {
            this.setState({ selected_location: currentLocationData });
          }
        } catch (error) {
          console.log("Axios Request Failed:", error.message);
        }
      };
      

    componentDidMount = async () => {
        this.getCommons();
        this.getLanguages();
        await this.getCountries();

        this.getResults(
            this.state.startDate, 
            this.state.selected_location, 
            this.state.selected_specialty,
            this.state.result_pageindex, 
            false, 
            this.state.selected_state
        );
    }

    renderSuggestionType(suggestion) {
        switch(suggestion.type) {
            case 'common_name':
                return "Layman's Term";
            default:
                return suggestion.type;
        }
    }

    renderSuggestionName(suggestion){
        if(suggestion.type === 'doctor' && suggestion.id === -1){
            return `Doctors named "${this.state.search_input_value}" (${suggestion.count})`;
        }else if(suggestion.type === 'facility' && suggestion.id === -1){
            return `Facilities named "${this.state.search_input_value}" (${suggestion.count})`;
        }
        else{
            return suggestion.name;
        }
    }

    onSearch(e){
        e.preventDefault();

        let _pageindex = 1
        this.setState({result_pageindex: _pageindex});
        this.updateMetadata(this.state.selected_specialty, this.state.selected_location, this.state.selected_state);

        this.getResults(this.state.startDate, this.state.selected_location, this.state.selected_specialty, _pageindex, false, this.state.selected_state);
    }

    handleSpecialtySelectChange = selectedValue => {
        selectedValue.label = selectedValue.value._label;

        this.setState({
            selected_specialty: selectedValue,
            search_input_value: selectedValue.label
        });

        var locationField = document.getElementById("locationField");

        if(selectedValue.value.type === 'doctor' && selectedValue.value.id !== -1){
            locationField.classList.add("disabled");
        }else if(selectedValue.value.type === 'facility' && selectedValue.value.id !== -1){
            locationField.classList.add("disabled");
        }else{
            locationField.classList.remove("disabled");
        }
    };

    handleSpecialtyInputChange = (newValue, { action }) => {
        if (action === "input-change"){
            this.setState({
                search_input_value: newValue,
                selected_specialty: null
            });
            return newValue;
        }
    };

    handleOnFav(doctor_id, isFav, location_id){
        this.setState({
            results: this.state.results.map(el => ((el.id === doctor_id && el.location.id === location_id) ? Object.assign({}, el, { favorited: !isFav }) : el))
        });
    }

    handlePageChange = (event, value) => {
       this.setState({result_pageindex: value});
       this.getResults(this.state.startDate, this.state.selected_location, this.state.selected_specialty, value, false, this.state.selected_state);
    };

    handleFilterDateChange(val){
        let _date = moment(val,'YYYY-MM-DD')
        this.setState({
            startDate: _date
        })
    }

    handleMeridiemChange(selected){
        this.setState({ meridiem: selected }, function () {
            this.getResultsBasedOnDate(this.state.startDate);
        });
    }

    handleLanguageChange(selected){
        this.setState({ language: selected }, function () {
            this.getResultsBasedOnDate(this.state.startDate);
        });
    }

    handleFeatureChange(selected){
        this.setState({ feature: selected }, function () {
            this.getResultsBasedOnDate(this.state.startDate);
        });
    }

    getMetaTitle(_search, _location, _state){
        if(_search){
            return `Find ${_search.label}${_search.value.type === 'panelship' ? ' panels' : ''} near ${_state?.name || _location?.name || 'me'}`;
        }else{
            return 'Find doctors and clinics near me';
        }
    }

    getMetaDesc(_search, _location, _state){
        let search_type = _search ? _search.value.type : null;
        let meta_desc = '';

        switch(search_type){
            case 'specialty':
                var specialty_info = _search.value?.info || _search.label || '';
                if(_search.value?.layman_terms){
                    specialty_info += ','+_search.value.layman_terms;
                }
                meta_desc = `All doctors/dentists specializing in ${specialty_info} near ${_state?.name || _location?.name || 'me'}. View available time slots.`;
                break;
            case 'common':
            case 'service':
                meta_desc = `All doctors/dentists ${search_type === 'service' ? 'providing' : 'specializing in'} ${_search.label} near ${_state?.name || _location?.name || 'me'}. View available time slots.`;
                break;
            case 'common_name':
            case 'panelship':
                meta_desc = `All ${_search.label} near ${_state?.name || _location?.name || 'me'}. View ${search_type === 'common_name' ? 'doctor/dentist profile and available time slots' : 'clinic/hospital profile'}`
                break;
            default:
                meta_desc = 'All doctors and clinics near me. View available time slots.'
        }
        return meta_desc;
    }

    getMetaKeywords(_search, _location, _state){
        var keywords = '';
        if(_search && _search.value?.layman_terms){
            keywords += `,${_search.value?.layman_terms}`;
        }
        if(_search){
            keywords += `,${_search.label}`
        }
        if(_location){
            keywords += `,${_location.name}`
        }else{
            keywords += ',near me'
        }
        if(_state && _state?.name){
            keywords += `,${_state.name}`
        }

        return keywords;
    }

    updateMetadata(){
        this.setState(prevState => ({
            metadata: {
                ...prevState.metadata,
                title: this.getMetaTitle(this.state.selected_specialty, this.state.selected_location, this.state.selected_state),
                description: this.getMetaDesc(this.state.selected_specialty, this.state.selected_location, this.state.selected_state),
                keywords: this.getMetaKeywords(this.state.selected_specialty, this.state.selected_location, this.state.selected_state)
            }
        }))
    }

    handleLocationSelectChange = selectedLocation => {
        this.setState({ selected_location: selectedLocation, states: selectedLocation.states || [], selected_state: null })
    };

    render() {
        const HighlightSubstring = ({ text, substring }) => {
            if (!substring) return <span>{text}</span>;
          
            const parts = text.split(new RegExp(`(${substring})`, "gi")); // Split by the substring (case-insensitive)
          
            return (
              <span>
                {parts.map((part, index) =>
                  part.toLowerCase() === substring.toLowerCase() ? (
                    <b key={index}>{part}</b> // Bold the matching substring
                  ) : (
                    part // Render non-matching parts normally
                  )
                )}
              </span>
            );
          };
          
        const promiseOptions2 = inputValue =>
        new Promise((resolve, reject) => {
            if(inputValue.length >= 2){
                axios.get(`${process.env.REACT_APP_API_URL}suggestions?keyword=${encodeURIComponent(inputValue)}`).then(res => {
                    resolve(res.data.map((suggestion) => {
                        if(suggestion.id === -1 && (suggestion.type === 'doctor' || suggestion.type === 'facility')){
                            suggestion.count = suggestion.name
                            suggestion.name = this.state.search_input_value
                        }
                        suggestion._label = this.renderSuggestionName(suggestion)
                        return { value: suggestion, label:
                        (<div className="label specialty-label">
                            <span className="suggestion-name">
                                <HighlightSubstring text={this.renderSuggestionName(suggestion)} substring={inputValue} />
                            </span>
                            <span className="suggestion-type">
                                {this.renderSuggestionType(suggestion)}
                            </span>
                        </div>) }}))
                })
            }else{
                resolve([]);
            }
        });

        return (
        <div className="result-page">
            <SEO 
            title={this.state.metadata.title} 
            description={this.state.metadata.description}
            type={this.state.metadata.type}
            keywords={this.state.metadata.keywords} />
            {/* main section */}
            <div className="main-section">
                <div className="container">
                    <h1 className="main-title">FIND HEALTHCARE PROFESSIONALS</h1>
                    <h2 className="main-sub-title">Hassle-free integrated online eco-system for finding and booking healthcare professionals</h2>

                    <div className="search-bar w-100">
                        <form className="section-form" onSubmit={this.onSearch}>
                            <div className="form-group speciality-group">
                                <AsyncSelect className="speciality-field" placeholder="Specialty, Service, Doctor, Clinic, etc." cacheOptions loadOptions={promiseOptions2} defaultOptions={this.state.specialties} onInputChange={this.handleSpecialtyInputChange} onChange={this.handleSpecialtySelectChange} defaultValue={this.state.selected_specialty} inputValue={this.state.search_input_value} value={this.state.selected_specialty} closeMenuOnSelect={true}/>
                            </div>

                            <div className="form-group location-group">
                                <Select id="locationField" className="location-field" defaultValue={this.state.selected_location} options={this.state.locations} getOptionLabel={(option)=>option.name} getOptionValue={(option)=>option} placeholder="Select Location" onChange={this.handleLocationSelectChange}/>
                                <Select id="stateField" className="state-field" defaultValue={this.state.selected_state} options={this.state.states} getOptionLabel ={(option)=>option.name} getOptionValue ={(option)=>option} placeholder="Select Area/State" onChange={state => this.setState({ selected_state: state })} value={this.state.selected_state}/>
                                <div className="form-group button-group">
                                    <button className="btn search-btn section-btn w-100" type="submit">Search</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="result-list-container">
                <div className="container-lg">
                    <div className="filter-bar">
                        <div className="left-filters">
                            <TextField
                                className="filter-field"
                                id="standard-password-input"
                                type="date"
                                autoComplete="current-password"
                                value={this.state.startDate.format('YYYY-MM-DD')}
                                onChange={(e) => this.handleFilterDateChange(e.target.value)}
                                inputProps={{min: moment().format('YYYY-MM-DD') }}
                                label="Date"
                                />
                            <Autocomplete
                                className="filter-field"
                                value={this.state.meridiem}
                                onChange={(e,val) => this.handleMeridiemChange(val)}
                                options={global.constant.time_options}
                                getOptionLabel={(option) => option.label ? option.label : ""}
                                getOptionSelected={(option, selected) => option.value === selected.value }
                                id="meridiem-field"
                                selectOnFocus
                                renderInput={(params) => <TextField {...params} label="Time" margin="normal" />}
                            />
                            <Autocomplete
                                className="language-field filter-field"
                                value={this.state.language}
                                onChange={(e,val) => this.handleLanguageChange(val)}
                                options={this.state.languages}
                                getOptionLabel={(option) => option ? option : ""}
                                getOptionSelected={(option, selected) => option === selected }
                                id="language-field"
                                selectOnFocus
                                renderInput={(params) => <TextField {...params} label="Language" margin="normal" />}
                            />
                            <Autocomplete
                                className="filter-field"
                                value={this.state.feature}
                                onChange={(e,val) => this.handleFeatureChange(val)}
                                options={this.state.feature_options}
                                getOptionLabel={(option) => option.label ? option.label : ""}
                                getOptionSelected={(option, selected) => option.value === selected.value }
                                id="feature-field"
                                selectOnFocus
                                renderInput={(params) => <TextField {...params} label="Feature" margin="normal" />}
                            />

                        </div>
                        <div className="mobile-filters">
                            <button className="btn btn-link" onClick={() => this.handleFilterModal(true)}><img src={filter_icon} alt='filter' /></button>
                        </div>
                        {(() => {
                            if (this.state.activeView !== 'map_view') {
                                return (
                                    <div className="right-items">
                                        <img className="map-icon" src={map_icon} alt='map' />
                                        <button className="btn btn-link map-view-btn" onClick={this.handleToggleView} name="map_view">Map View</button>
                                    </div>
                                );
                            } else {
                                return (
                                    <div className="right-items">
                                        <img className="map-icon" src={list_icon} alt='list' />
                                        <button className="btn btn-link map-view-btn" onClick={this.handleToggleView} name="list_view">List View</button>
                                    </div>);
                            }
                        })()}
                    </div>

                    <div className="loader d-none" id="results-loader"><Spinner animation="border" className="spinner"/></div>
                    <div id="results-list">
                        {(() => {
                            if (_.isEmpty(this.state.error_result)) {
                                return (_.isEmpty(this.state.results) ?
                                    <div className="loader no-result-div">
                                        <p>We are sorry, there is no doctor that matches the criteria you selected.</p>
                                        <p>We are in the process of recruiting more doctors into the platform. Do let us know if there is any particular preferred doctor/specialty that you are interested in. Your feedback will help improve convenience for all.</p>
                                        <p>You may contact us <a className="contact-us-here" href={`${process.env.REACT_APP_MAIN_SITE_URL}/contact-us/`} target="_blank" rel="noreferrer">here</a>.</p>
                                    </div> : (<React.Fragment>
                                    <ResultListView activeView={this.state.activeView} results={this.state.results} onGetResultsBasedOnDate={this.getResultsBasedOnDate} start_date={this.state.startDate} onFav={this.handleOnFav} meta={this.state.meta} loading_result={this.state.loading_result}/>
                                    <ResultMapView activeView={this.state.activeView} results={this.state.results} onFav={this.handleOnFav}/>
                                    <Pagination className="container" count={this.state.meta.total_pages} page={this.state.page_no} onChange={this.handlePageChange}/>
                                    </React.Fragment>)
                                );
                            } else {
                                return <Error message={this.state.error_result}></Error>;
                            }
                        })()}
                    </div>

                    <FilterModal showFilterModal={this.state.showFilterModal} handleFilterModal={this.handleFilterModal} startDate={this.state.startDate} handleFilterDateChange={this.handleFilterDateChange} handleMeridiemChange={this.handleMeridiemChange} meridiem={this.state.meridiem} handleLanguageChange={this.handleLanguageChange} language={this.state.language} languages={this.state.languages} handleFeatureChange={this.handleFeatureChange} feature={this.state.feature}/>
                </div>
            </div>
        </div>
    )};
}

export { Result };
